import React, { useRef, useEffect } from 'react';

interface TranscriptEntry {
  source: 'ai' | 'user';
  message: string;
  timestamp: Date;
}

interface CXTranscriptProps {
  transcript: TranscriptEntry[];
  isSpeaking: boolean;
  agentName: string;
}

export const CXTranscript: React.FC<CXTranscriptProps> = ({
  transcript,
  isSpeaking,
  agentName
}) => {
  const scrollRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [transcript, isSpeaking]);

  return (
    <div className="h-full flex flex-col bg-gray-50">
      {/* Transcript */}
      <div
        ref={scrollRef}
        className="flex-1 overflow-y-auto p-6 space-y-3"
      >
        {transcript.map((item, index) => (
          <div
            key={index}
            className={`flex ${item.source === 'user' ? 'justify-end' : 'justify-start'}`}
          >
            <div
              className={`max-w-[80%] rounded-lg px-4 py-2 ${
                item.source === 'user'
                  ? 'bg-pink-500 text-white'
                  : 'bg-white text-gray-800 shadow-sm'
              }`}
            >
              <p className="text-sm">{item.message}</p>
              <p className={`text-xs mt-1 ${
                item.source === 'user' ? 'text-pink-100' : 'text-gray-500'
              }`}>
                {item.timestamp.toLocaleTimeString('en-US', {
                  hour: '2-digit',
                  minute: '2-digit',
                })}
              </p>
            </div>
          </div>
        ))}

        {/* Typing indicator */}
        {isSpeaking && (
          <div className="flex justify-start">
            <div className="bg-white rounded-lg px-4 py-3 shadow-sm">
              <div className="flex space-x-2">
                <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
                <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
                <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};